const APIS = {
  USER: "/usermanagementservice/api/user/",
  SUBSCRIPTION:"client-subscription/get-client-info/",
  CONFIGURATION:"/projectsettingsservice/api/configuration/"
};

export default APIS;
